import { _invertMap } from '@naturalcycles/js-lib';
export var EventType;
(function (EventType) {
    /**
     * @deprecated no longer used since year circa 1625
     */
    EventType["CHANGE_PLAN"] = "CHANGE_PLAN";
    EventType["CHANGE_GOAL"] = "CHANGE_GOAL";
    EventType["NO_LONGER_PREGNANT"] = "NO_LONGER_PREGNANT";
    EventType["CHANGE_HW"] = "CHANGE_HW";
})(EventType || (EventType = {}));
export const eventTypeToCode = new Map([
    [EventType.CHANGE_PLAN, 1],
    [EventType.CHANGE_GOAL, 2],
    [EventType.NO_LONGER_PREGNANT, 3],
    [EventType.CHANGE_HW, 4],
]);
export const eventTypeByCode = _invertMap(eventTypeToCode);
export var HardwareId;
(function (HardwareId) {
    HardwareId[HardwareId["ORAL_THERMOMETER"] = 1] = "ORAL_THERMOMETER";
    HardwareId[HardwareId["OURA"] = 2] = "OURA";
    HardwareId[HardwareId["UEBE_THERMOMETER"] = 3] = "UEBE_THERMOMETER";
    HardwareId[HardwareId["T3_THERMOMETER"] = 4] = "T3_THERMOMETER";
    HardwareId[HardwareId["APPLE_WATCH"] = 5] = "APPLE_WATCH";
    HardwareId[HardwareId["B1"] = 6] = "B1";
    // Samsung watch is only used in Natsung (not NC) and therefore commented out
    // SAMSUNG_WATCH = 7,
    HardwareId[HardwareId["SAMSUNG_RING"] = 8] = "SAMSUNG_RING";
})(HardwareId || (HardwareId = {}));
export const HARDWARE_WEARABLES = [HardwareId.OURA, HardwareId.APPLE_WATCH, HardwareId.B1];
export const HARDWARE_THERMOMETERS = [
    HardwareId.ORAL_THERMOMETER,
    HardwareId.UEBE_THERMOMETER,
    HardwareId.T3_THERMOMETER,
];
export const HARDWARE_CONNECTED_THERMOMETERS = [
    HardwareId.UEBE_THERMOMETER,
    HardwareId.T3_THERMOMETER,
];
